/** filterType for free-text client search (business name + email indexes). */
export const CLIENT_TEXT_SEARCH_FILTER_TYPE = "businessNameLowercase";

export const isClientTextSearch = (filterType) =>
  filterType === CLIENT_TEXT_SEARCH_FILTER_TYPE;
